<!-- 
HACCP情報画面の月情報ピッカー
@slot
  prefix : 月情報ピッカーの左側に表示するコンテンツ
-->

<template>
  <div>
    <v-row align="center">
      <v-col style="text-align: center">
        <v-btn
          text
          v-show="!showMonthPicker"
          :disabled="!allowBackDate"
          @click="previousMonth"
        >
          <v-icon>mdi-menu-left</v-icon>
        </v-btn>
        <v-btn
          text
          @click="showMonthPicker = !showMonthPicker"
          :disabled="showMonthPicker"
          >{{ localizedMonth }}</v-btn
        >
        <v-btn
          text
          v-show="!showMonthPicker"
          :disabled="!allowNextMonth"
          @click="nextDate"
        >
          <v-icon>mdi-menu-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-show="showMonthPicker" justify="center">
      <v-date-picker
        locale="jp"
        v-model="month"
        type="month"
        elevation="12"
        :width="400"
        :day-format="pickupMonth"
        :min="monthRange.min"
        :max="monthRange.max"
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="monthPickerClose">キャンセル</v-btn>
        <v-btn text color="primary" @click="monthPickerApply">OK</v-btn>
      </v-date-picker>
    </v-row>
  </div>
</template>

<script>
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  data() {
    this.dispYear1 = "";
    this.month = "";
    this.monthRange = { min: "", max: "" };
    return {
      showMonthPicker: false,
      searchMonth: this.searchMonth,
    };
  },
  methods: {
    /**
     * 検索対象月を更新する
     */
    updateSearchMonth(dispYear1, newSearchMonth, fromUmilog = false, withShell = false) {
      this.dispYear1 = dispYear1;
      this.searchMonth = newSearchMonth;
      this.month = newSearchMonth;
      this.fromUmilog = fromUmilog;
      this.withShell = withShell;
      if (this.fromUmilog) {
        this.monthRange.min = this.dispYear1 + "-02";
        this.monthRange.max = this.dispYear1 + "-11";
      } else {
      console.log(this.withShell);
        if (this.withShell) {
          this.monthRange.min = this.dispYear1 + "-7";
        } else {
          this.monthRange.min = this.dispYear1 + "-10";
        }
        this.monthRange.max = (Number(this.dispYear1) + 1).toString() + "-06";
      }
      this.$emit("on-select-calendar-month", this.searchMonth);
    },
    /**
     * 戻るボタンが押下された
     */
    backToHome() {
      this.$router.push("/product");
    },
    /**
     * カレンダーピッカーを閉じる
     */
    monthPickerClose() {
      const cancelled = this.parseMonthInfo(this.searchMonth, 0);
      this.month = cancelled.month;
      this.showMonthPicker = false;
    },
    /**
     * カレンダーピッカーの選択月を検索対象月に反映する
     */
    monthPickerApply() {
      this.updateSearchMonth(this.dispYear1, this.month, this.fromUmilog, this.withShell);
      this.monthPickerClose();
    },
    /**
     * 月文字列をオフセット日だけずらして返却する
     */
    parseMonthInfo(dateString, offsetDays) {
      const currentDate = new DateWrapper(dateString).appendDay(offsetDays);
      const currentMonth = currentDate.format.build(
        (d) => `${d.date.y}-${d.date.m02}`
      );
      return {
        month: currentMonth,
      };
    },
    /**
     * 翌月に移動する
     */
    nextDate() {
      const today = this.parseMonthInfo(this.searchMonth, 0);
      // 翌月は31日分後ろにずらす
      const next = this.parseMonthInfo(this.searchMonth, 31);
      this.updateSearchMonth(this.dispYear1, next.month, this.fromUmilog, this.withShell);
      if (today.month != next.month) {
        this.pickerDate = next.month;
      }
    },
    /**
     * 前月に移動する
     */
    previousMonth() {
      const today = this.parseMonthInfo(this.searchMonth, 0);
      // 前月は1日分前にずらす
      const previous = this.parseMonthInfo(this.searchMonth, -1);
      this.updateSearchMonth(this.dispYear1, previous.month, this.fromUmilog, this.withShell);
      if (today.month != previous.month) {
        this.pickerDate = previous.month;
      }
    },
    /**
     * 対象月を取得する
     */
    pickupMonth(date_string) {
      return new DateWrapper(date_string).format.build((d) => `${d.date.d}`);
    },
  },
  computed: {
    /**
     * 検索対象月を表示月に変換して返す
     * うみログからの要求は3か月表示
     */
    localizedMonth() {
      if (this.fromUmilog) {
        return new DateWrapper(this.searchMonth).format.localized3Month;
      } else {
        return new DateWrapper(this.searchMonth).format.localizedMonth;
      }
    },
    /**
     * 翌月に移動できるのならtrueを返す
     */
    allowNextMonth() {
      if (
        new DateWrapper(this.searchMonth)
          .appendDay(1)
          .compare(this.monthRange.max) >= 1
      ) {
        return false;
      }
      return true;
    },
    /**
     * 前月に移動できるのならtrueを返す
     */
    allowBackDate() {
      if (
        new DateWrapper(this.searchMonth)
          .appendDay(-1)
          .compare(this.monthRange.min) <= 1
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>

<!--DatePickerのスタイルを継承して書き換え、2つ目で改行するようにする -->
<style>
.v-date-picker-table th {
  background-color: #ffffff !important;
}

.v-date-picker-table__events {
  max-width: 20px !important;
  left: 6px !important;
  top: 24px !important;
}

.v-date-picker-table--date div {
  float: left !important;
  margin-bottom: 1px !important;
  margin-left: 1px !important;
  margin-right: 0px !important;
  margin-top: 0px !important;
}

.no-background-color {
  background-color: transparent !important;
  border-color: transparent !important;
}
</style>
